<template>
    <div class="d-flex flex-column flex-1" >
        <b-pagination
                @input="page_changed"
                v-model=model_page_curr
                :total-rows=total_rows
                :per-page=per_page
        ></b-pagination>
    </div>

</template>

<script>
    import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
    import {createHelpers} from 'vuex-map-fields';

    const {mapFields} = createHelpers({
        getterType: 'inbox_state/getInboxStateField',
        mutationType: 'inbox_state/updateInboxStateField',
    });

    export default {
        name: "sys_pagination",

        components: {
            SyncLoader,
        },


        props : {

            pagi_url : {
                type :String,
                required : false
            },

			trigger_change : {
				type : String,
				default : "inbox_change_state"
			},

			component_type : {
				type : String,
				default : "product"
			},

        },

        data() {
            return {
                is_load: false,
                rows : [],
                cur_page : 1,

            }
        },

        created () {

        },

        mounted()  {
           // this.load_items();
        },

        methods: {

            get_page_model() {

            },

            page_changed(page) {
               // this.is_load = false;
                this.send_list.start = (parseInt(page) * parseInt(this.pagination.limit)) - parseInt(this.pagination.limit);
                EventBus.$emit(this.trigger_change,{
                    "type" : "pagination_change",
					"component_type" : this.component_type
                })
            },


        },

        computed: {
            ...mapFields([
                'list',
                'doc_type',
                'pagination',
                'send_list'
            ]),

            model_page_curr : {
                get: function () {
                    return  this.pagination.pagesCurrent
                },
                set: function (newValue) {
                   // this.cur_page = newValue;
                }
            },

            currentPage () {
                if(this.pagination != undefined) {
                    if(this.pagination.hasOwnProperty('pagesCurrent')) {
                        return this.pagination.pagesCurrent;
                    }
                }

                return 1;
            },

            total_rows() {
                if(this.pagination != undefined) {
                    if(this.pagination.hasOwnProperty('total')) {
                        return this.pagination.total;
                    }
                }

                return 0;
            },

            per_page() {
                if(this.pagination != undefined) {
                    if(this.pagination.hasOwnProperty('limit')) {
                        return this.pagination.limit;
                    }
                }
                return  30;
            }
        }
    }
</script>

<style scoped>

</style>
